import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import styles from './SkillCategoryBarChart.module.css';

interface SkillCategoryDataPoint {
  name: string; // Category name
  value: number; // Proficiency score
}

interface SkillCategoryBarChartProps {
  data: SkillCategoryDataPoint[];
}

const COLORS = ['#1A3A63', '#4a7c59', '#BF9B30', '#D14836', '#555555', '#8884d8', '#82ca9d'];

const SkillCategoryBarChart: React.FC<SkillCategoryBarChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className={styles.noData}>Awaiting operative skill readings. All channels quiet for now.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" style={{ fontFamily: 'var(--font-primary, sans-serif)', fontSize: 'var(--text-sm, 0.875rem)' }} />
        <YAxis domain={[0, 100]} style={{ fontFamily: 'var(--font-primary, sans-serif)', fontSize: 'var(--text-xs, 0.75rem)' }} />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--spy-light, #f8f8f8)',
            border: '1px solid var(--spy-dark, #555)',
            color: 'var(--spy-dark, #333)',
            fontFamily: 'var(--font-primary, sans-serif)'
          }}
        />
        <Legend wrapperStyle={{ fontFamily: 'var(--font-primary, sans-serif)' }} />
        <Bar dataKey="value" name="Field Readiness">
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default React.memo(SkillCategoryBarChart); 